import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http'; 
import {RoutingService} from '../../services/routing.service';

@Component({
  selector: 'app-legal',
  templateUrl: './legal.component.html',
  styleUrls: ['./legal.component.css']
})
export class LegalComponent implements OnInit {
  references: { number: number, description: string }[] = []; // Crear una propiedad para almacenar las referencias

  constructor(private http: HttpClient, public routes: RoutingService) { }

  ngOnInit() {
    this.getReferences();  // Llamar a la función que obtiene las referencias
  }

  getReferences() {
    const url = 'https://api.calobesidad.innsider.com.co/api/legals/'; // Reemplazar con la URL real del endpoint

    this.http.get<{ number: number, description: string }[]>(url).subscribe(
      (data) => {
        this.references = data; // Asignar los datos de las referencias a la propiedad
      },
      (error) => {
        console.error('Error al obtener las referencias:', error);
      }
    );
  }
}
